<template>
    <div>
        <b-modal
            id="modify-word-table-popup"
            ref="modal"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            modal-class="hide-footer"
            :hide-header-close="loading"
            @hidden="onHidden"
        >
            <div>
                <b-table
                    id="adverse-media-table"
                    class="table table-striped table-bordered table-sm"
                    :items="items"
                    small
                >
                    <template slot="status" slot-scope="score_items">
                        <div class="action-review">
                            <!-- if action modify -->
                            <base-action
                                label="Modify"
                                @click="
                                    selectedRecord(score_items.item)
                                    $bvModal.show('modify-word-score-popup')
                                "
                            ></base-action>
                            <!-- if action archive -->
                        </div>
                    </template>
                </b-table>
                <!-- <b-table :items="items">
            <template slot="thead">
                <thead>
                <tr>
                    <th id="header-id" scope="col" v-b-popover.hover="'Sort by ID'">Score</th>
                    <th id="header-name" scope="col" v-b-popover.hover="'Sort by Name'">Proximity</th>
                    <th id="header-value" scope="col" v-b-popover.hover="'Sort by Value'">Action</th>
                </tr>

                    <template slot="status" slot-scope="items">
                    <div class="action-review">
          
                        <base-action
                            icon="icon-edit"
                            label="Modify"
                            @click="
                                selectedRecord(score_items.item)
                                $bvModal.show('modify-word-score-popup')
                            "
                        ></base-action>

              
                    </div>
                </template>

                
                </thead>
            </template>
        </b-table> -->
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { BPopover } from 'bootstrap-vue'

export default {
    components: {
        BPopover,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        title: {
            type: String,
            default: null,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),

            high: '',
            low: '',
            medium: '',

            items_bin_score: [
                { score: '1-10 words', proximity: 'Close', status: '' },
                { score: '11-50 words', proximity: 'Medium', status: '' },
                { score: '50-100 words', proximity: 'Far', status: '' },
            ],

            word_fields: [
                {
                    key: 'status',
                    label: 'ACTION',
                    class: 'two-list',
                },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),

        titlePopup() {
            return ' ' + (this.selectedItem ? this.formData.factor : '')
        }, // End of titlePopup() method

        buttonLabel() {
            return 'Update'
        },
        highLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction'
                : 'High'
        },
        highPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Sanction Scale'
                : 'High Scale'
        },
        lowLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium'
                : 'Low'
        },
        lowPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'Medium Scale'
                : 'Low Scale'
        },
        mediumLabel() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High'
                : 'Medium'
        },
        mediumPlaceholder() {
            return this.formData.factor === 'Assets Under Management' ||
                this.formData.factor === 'Suspicious Activity Reports'
                ? 'High Scale'
                : 'Medium Scale'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            console.log('watch value', value)
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, JSON.parse(JSON.stringify(value)))
            } else {
                this.onHidden()
            }
        },
        /**
         * Handle when the popup hide
         *
         * @return {void}
         */
        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                _id: null,

                n_close: '',
                n_far: '',
                n_medium: '',
                score: '',
            }
        }, // End of initializeFormData() method
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.$store.commit('onSubmit', null)
            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method
        /**
         * Handle when the modal is canceled
         *
         * @return {void}
         */
        async onSubmit() {
            const result = await this.$validator.validateAll()
            console.log('submit', this.formData)
            if (result) {
                try {
                    await this.$store.dispatch('onSubmit', this.formData)
                } catch (error) {
                    console.log(error, 'There is an error on submit')
                }
            }
        }, // End of onSubmit() method
    }, // End of Component > methods
}
</script>
